import { Controller } from "@hotwired/stimulus"
import { fixedTooltipPosition } from "../src/fixed_tooltip_position.js"

// Podpowiedzi w przewijanym kontenerze (np. kolumnie kanbanu) - span z `group-hover:block` wewnątrz
// elementu `.group` - były ucinane na krawędzi kontenera (overflow przycina absolute). Na czas
// najechania przełączamy podpowiedź na position: fixed i liczymy jej miejsce względem elementu;
// fixed nie jest przycinany przez overflow przodków. Znaczniki podpowiedzi zostają bez zmian.
//
// Użycie: data-controller="fixed-tooltip" na kontenerze z podpowiedziami.
export default class extends Controller {
  connect() {
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.reset = this.reset.bind(this)
    this.element.addEventListener("mouseover", this.show)
    this.element.addEventListener("mouseout", this.hide)
    // przewinięcie kolumny przesuwa element spod podpowiedzi - wracamy do zwykłego ułożenia
    this.element.addEventListener("scroll", this.reset, true)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this.show)
    this.element.removeEventListener("mouseout", this.hide)
    this.element.removeEventListener("scroll", this.reset, true)
    this.reset()
  }

  show(event) {
    const trigger = event.target.closest(".group")
    if (!trigger || trigger === this.trigger || !this.element.contains(trigger)) return

    const tip = [...trigger.children].find((child) => child.classList.contains("group-hover:block"))
    if (!tip) return

    this.reset()
    this.trigger = trigger
    this.tip = tip
    this.originalStyle = tip.getAttribute("style")
    Object.assign(tip.style, {
      position: "fixed", top: "0px", left: "0px", right: "auto", bottom: "auto", margin: "0", translate: "none",
    })

    // podpowiedź jest już widoczna (group-hover), więc da się ją zmierzyć
    const box = fixedTooltipPosition(
      trigger.getBoundingClientRect(),
      { width: tip.offsetWidth, height: tip.offsetHeight },
      { width: window.innerWidth, height: window.innerHeight },
    )
    tip.style.left = `${box.left}px`
    tip.style.top = `${box.top}px`
  }

  hide(event) {
    // mouseout leci też przy przejściu między dziećmi elementu - chowamy dopiero po wyjściu z niego
    if (!this.trigger || this.trigger.contains(event.relatedTarget)) return

    this.reset()
  }

  reset() {
    if (!this.tip) return

    if (this.originalStyle === null) {
      this.tip.removeAttribute("style")
    } else {
      this.tip.setAttribute("style", this.originalStyle)
    }
    this.tip = null
    this.trigger = null
  }
}
